export const BRAND = {
  name: "Blackthorn",
  tagline: "Verified, not guessed.",
  position: "Verification, whitelists, anti-raid, and moderation for Discord servers.",
  colors: {
    bgPrimary: "#0c0c0e",
    bgSecondary: "#1a1a1d",
    bgTertiary: "#232327",
    textPrimary: "#e8e6e3",
    textMuted: "#8a8a8f",
    accent: "#8f1d2c",
    accentHover: "#a82536",
    steel: "#4a4a52",
  },
} as const;

export const AUDIT_ACTIONS = {
  VERIFICATION_STARTED: "verification.started",
  VERIFICATION_COMPLETED: "verification.completed",
  VERIFICATION_REJECTED: "verification.rejected",
  VERIFICATION_EXPIRED: "verification.expired",
  IDENTITY_LINKED: "identity.linked",
  IDENTITY_UNLINKED: "identity.unlinked",
  IDENTITY_REVOKED: "identity.revoked",
  WHITELIST_APPROVED: "whitelist.approved",
  WHITELIST_REMOVED: "whitelist.removed",
  ROLES_SYNCED: "roles.synced",
  SECURITY_CONFIG_CHANGED: "security.config_changed",
  RAID_DETECTED: "security.raid_detected",
  SPAM_DETECTED: "security.spam_detected",
  LOCKDOWN_ENABLED: "security.lockdown_enabled",
  LOCKDOWN_DISABLED: "security.lockdown_disabled",
  MOD_ACTION: "moderation.action",
  STAFF_OVERRIDE: "staff.override",
  INTEGRATION_CONFIG_CHANGED: "integration.config_changed",
  VPN_BLOCKED: "verification.vpn_blocked",
  ALT_FLAGGED: "verification.alt_flagged",
  BANNED_BLOCKED: "verification.banned_blocked",
  AUTH_FAILURE: "auth.failure",
} as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[keyof typeof AUDIT_ACTIONS];

export const SECURITY_DEFAULTS = {
  antiRaid: { joinThreshold: 10, joinWindowSeconds: 60, raidModeSeconds: 120, lockdownOnRaid: false, minAccountAgeDuringRaidDays: 7 },
  antiBot: { minAccountAgeDays: 7, maxFailedVerifications: 3 },
  antiSpam: { maxMessagesPerWindow: 6, windowSeconds: 10, maxMentionsPerMessage: 5 },
  verification: { tokenTtlSeconds: 600, maxAltScore: 70, blockVpn: false },
} as const;

/** Discord permission bits (least-privilege set documented in README). */
export const BOT_INTENTS = ["Guilds", "GuildMembers", "GuildMessages", "MessageContent", "GuildModeration", "GuildMessageReactions"] as const;

export const OAUTH_SCOPES = ["identify", "guilds"] as const;

export const SESSION_COOKIE = "bt_session";
export const OAUTH_STATE_COOKIE = "bt_oauth_state";
